import { render } from "./QuickBox.vue?vue&type=template&id=7fc3befd&scoped=true"
import script from "./QuickBox.vue?vue&type=script&lang=js"
export * from "./QuickBox.vue?vue&type=script&lang=js"

import "./QuickBox.vue?vue&type=style&index=0&id=7fc3befd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc3befd"]])

export default __exports__